import type { DebugStateHandler } from '../offerSystemTypes';

export class OfferEditorStateInfo<S, SH extends DebugStateHandler<S>> {
  public readonly element = document.createElement('div');

  constructor(
    private readonly state: S,
    private readonly stateHandler: SH,
  ) {
    Object.assign(this.element.style, {
      position: 'fixed',
      top: '0',
      left: '200px',
      color: '#F5F5F5',
      backgroundColor: '#1c1c1c',
      fontFamily: 'sans-serif',
      padding: '0.5em',
    });
    document.body.appendChild(this.element);

    setInterval(this.update, 200);
  }

  private readonly update = (): void => {
    const text = this.stateHandler.getInfo(this.state);

    if (text === this.element.innerText) return;
    this.element.innerText = text;
  };
}
